var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuidedAssist(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,4.8A4.8,4.8,0,0,0,7.2,9.6H9.6a2.4,2.4,0,0,1,4.8,0c0,2.4-3.6,2.1-3.6,6h2.4c0-2.7,3.6-3,3.6-6A4.8,4.8,0,0,0,12,4.8Zm0,16.8A9.6,9.6,0,1,1,21.6,12,9.613,9.613,0,0,1,12,21.6ZM12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0ZM10.8,19.2h2.4V16.8H10.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidedAssist);
export default __webpack_public_path__ + "static/media/GuidedAssist.2196559a0465f4f2aad5b0fccbb48761.svg";
export { ForwardRef as ReactComponent };